module.exports = __webpack_public_path__ + "6ba51100a361eb2cec401fe9e8a1b2db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/warning-mark.png
// module id = 756
// module chunks = 0